import { defineComponent as g, h as C, computed as i } from "vue";
import v from "./highrise902.mjs";
import x from "./highrise677.mjs";
import l from "./highrise678.mjs";
import { useThemeClass as y } from "./highrise680.mjs";
import T from "./highrise903.mjs";
const b = Object.assign(Object.assign({}, l.props), {
  depth: [String, Number]
}), S = g({
  name: "P",
  props: b,
  setup(e) {
    const {
      mergedClsPrefixRef: s,
      inlineThemeDisabled: n
    } = x(e), m = l("Typography", "-p", v, T, e, s), o = i(() => {
      const {
        depth: r
      } = e, d = r || "1", {
        common: {
          cubicBezierEaseInOut: p
        },
        self: {
          pFontSize: h,
          pLineHeight: a,
          pMargin: c,
          pTextColor: f,
          [`pTextColor${d}Depth`]: u
        }
      } = m.value;
      return {
        "--n-bezier": p,
        "--n-font-size": h,
        "--n-line-height": a,
        "--n-margin": c,
        "--n-text-color": r === void 0 ? f : u
      };
    }), t = n ? y("p", i(() => `${e.depth || ""}`), o, e) : void 0;
    return {
      mergedClsPrefix: s,
      cssVars: n ? void 0 : o,
      themeClass: t == null ? void 0 : t.themeClass,
      onRender: t == null ? void 0 : t.onRender
    };
  },
  render() {
    var e;
    return (e = this.onRender) === null || e === void 0 || e.call(this), C("p", {
      class: [`${this.mergedClsPrefix}-p`, this.themeClass],
      style: this.cssVars
    }, this.$slots);
  }
});
export {
  S as default,
  b as pProps
};
